export default __webpack_public_path__ + "static/media/bee.0b9904ac.png";